function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.650052,0,0,1,29.4352,180.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0937493,0,0,0.0598958,-44.6669,-180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 42.667,
    r: 42.667,
    style: {
      fill: "rgb(51,51,51)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0937493,0,0,0.0598958,-44.6669,-180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 192,
    r: 42.667,
    style: {
      fill: "rgb(51,51,51)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0937493,0,0,0.0598958,-44.6669,-180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 341.333,
    r: 42.667,
    style: {
      fill: "rgb(51,51,51)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.c47782f7ebeef7822531a0ea9f6567de.svg";
export { ForwardRef as ReactComponent };